import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  galleryRoot: {
    display: 'flex',
    gap: 20,
    width: '100%',
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 16,
    },
  },
  mainImageBox: {
    flex: '1 1 0',
    // minWidth: 0,
    maxWidth: "100%",
    borderRadius: "8px",
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    background: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    aspectRatio: '16/9',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      aspectRatio: '16/10',
    },
  },
  fallbackMain: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.palette.background.secondary_hover,
    borderRadius: "8px",
  },
  mainImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: "8px",
  },
  verticalImageBox: {
    flex: '0 0 210px',
    minWidth: 160,
    maxWidth: "242px",
    borderRadius: "8px",
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    background: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flex: 'unset',
      minWidth: 0,
      maxWidth: '100%',
      height: 180,
      margin: '12px 0',
    },
  },
  fallbackVertical: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.palette.background.secondary_hover,
    borderRadius: "8px",
  },
  verticalImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: "8px",
  },
  gridImagesBox: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gap: 12,
    flex: '0 0 340px',
    minWidth: 180,
    maxWidth: 340,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flex: 'unset',
      minWidth: 0,
      maxWidth: '100%',
      height: 180,
      gap: 8,
    },
  },
  gridImageWrapper: {
    position: 'relative',
    borderRadius: "8px",
    overflow: 'hidden',
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fallbackGrid: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    background: theme.palette.background.secondary_hover,
    borderRadius: "8px",
  },
  gridImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: "8px",
  },
   showAllPhotosBtn: {
    position: 'absolute',
    bottom: 12,
    zIndex: 3,
    minWidth: '120px',
    borderRadius: '8px',
    fontWeight: 600,
    fontSize: '12px',
    background: theme.palette.background.paper,
    color: theme.palette.text.gray_700,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background 0.2s',
    '&:hover': {
      background: theme.palette.background.secondary_hover,
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.45)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    color: '#fff',
    borderRadius: "8px",
  },
  extraCount: {
    fontSize: 18,
    fontWeight: 700,
    background: 'rgba(0,0,0,0.3)',
    borderRadius: "6px",
    padding: '2px 10px',
    marginTop: 4,
  },
}));
